import ReinforcementDataStore from '../../datastores/ReinforcementDataStore';

// const data = {
//   challengeCourses: {
//     subscribed: []
//   }
// };
const data = {
  challengeCourses: {
    subscribedToSchedule: [
      {
        id: 111,
        reservationCode: 1,
        name: 'Refuerzo Académico: iLuis',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Lorem Ipsum Dolor Amet',
        shortDescription: 'Lorem Ipsum Dolor Amet',
        date: '2023-01-06',
        isReprog: true,
        isCancel: true,
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '17:00',
        endTime: '19:30',
        professor: [],
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 800,
        reservationCode: 123,
        name: 'Refuerzo Académico: Mate',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Lorem Ipsum Dolor Amet',
        shortDescription: 'Lorem Ipsum Dolor Amet',
        date: '2023-01-02',
        today: false,
        capacity: 10,
        address: 'Some Address',
        isReprog: true,
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '14:00',
        endTime: '15:30',
        professor: [],
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 112,
        reservationCode: 13,
        name: 'Refuerzo Académico: Geo',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Lorem Ipsum Dolor Amet',
        shortDescription: 'Lorem Ipsum Dolor Amet',
        date: '2022-08-02',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '14:00',
        endTime: '16:00',
        professor: [],
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 111,
        reservationCode: 1,
        name: 'Refuerzo Académico: Inglés',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Lorem Ipsum Dolor Amet',
        shortDescription: 'Lorem Ipsum Dolor Amet',
        date: '2022-08-01',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '13:00',
        endTime: '14:30',
        professor: [],
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 111,
        reservationCode: 1,
        name: 'Refuerzo Académico: Francés',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Lorem Ipsum Dolor Amet ABC',
        shortDescription: 'Lorem Ipsum Dolor Amet',
        date: '2021-07-13',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '09:15',
        endTime: '12:15',
        professor: [{ lastName: 'APELLIDO', firstName: 'SEGUNDO' }],
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 112,
        reservationCode: 1,
        name: 'Refuerzo Académico: Chino Mandarin',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Lorem Ipsum Dolor Amet',
        shortDescription: 'Lorem Ipsum Dolor Amet',
        date: '2021-07-12',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '10:15',
        endTime: '11:00',
        professor: 'GARY BERK',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 113,
        reservationCode: 1,
        name: 'Polaco Basico',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Lorem Ipsum Dolor Amet',
        shortDescription: 'Lorem Ipsum Dolor Amet',
        date: '2021-07-15',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '13:00',
        endTime: '14:00',
        professor: 'SAUL PEÑA',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 114,
        reservationCode: 1,
        name: 'Quimica Basica',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Lorem Ipsum Dolor Amet',
        shortDescription: 'Lorem Ipsum Dolor Amet',
        date: '2021-07-15',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '13:30',
        endTime: '14:15',
        professor: 'SANDRO RUIZ',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 115,
        reservationCode: 1,
        name: 'Fisica Basica',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Lorem Ipsum Dolor Amet',
        shortDescription: 'Lorem Ipsum Dolor Amet',
        date: '2021-07-15',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '12:30',
        endTime: '14:15',
        professor: 'LUIS GUERRA',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 118,
        reservationCode: 1,
        name: 'Refuerzo Académico: Latin Antiguo',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Lorem Ipsum Dolor Amet',
        shortDescription: 'Lorem Ipsum Dolor Amet',
        date: '2021-08-02',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '8:00',
        endTime: '8:45',
        professor: 'ELMER CENA',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 119,
        reservationCode: 1,
        name: 'Refuerzo Académico: Lenguas Muertas',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Lorem Ipsum Dolor Amet',
        shortDescription: 'Lorem Ipsum Dolor Amet',
        date: '2021-08-02',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '9:00',
        endTime: '9:45',
        professor: 'AGNES GLAVE',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 120,
        reservationCode: 1,
        name: 'Refuerzo Académico: Curso 1',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Refuerzo Académico: Curso 1',
        shortDescription: 'Refuerzo Académico: Curso 1',
        date: '2021-08-02',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '10:00',
        endTime: '10:45',
        professor: 'ROSA AGATHA',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 121,
        reservationCode: 1,
        name: 'Refuerzo Académico: Curso 2',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Refuerzo Académico: Curso 2',
        shortDescription: 'Refuerzo Académico: Curso 2',
        date: '2021-08-02',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '11:00',
        endTime: '11:45',
        professor: 'ROSA AGATHA',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 122,
        reservationCode: 1,
        name: 'Refuerzo Académico: Curso 3',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Refuerzo Académico: Curso 3',
        shortDescription: 'Refuerzo Académico: Curso 3',
        date: '2021-08-02',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '12:00',
        endTime: '12:45',
        professor: 'ROSA AGATHA',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 122,
        reservationCode: 1,
        name: 'Refuerzo Académico: Curso 3',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Refuerzo Académico: Curso 3',
        shortDescription: 'Refuerzo Académico: Curso 3',
        date: '2021-08-02',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '8:00',
        endTime: '9:30',
        professor: 'ROSA AGATHA',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 122,
        reservationCode: 1,
        name: 'Refuerzo Académico: Curso 3',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Refuerzo Académico: Curso 4',
        shortDescription: 'Refuerzo Académico: Curso 4',
        date: '2021-08-18',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '8:00',
        endTime: '9:30',
        professor: 'ROBERTO URIBE',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 122,
        reservationCode: 1,
        name: 'Refuerzo Académico: Curso 3',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Refuerzo Académico: Curso 5',
        shortDescription: 'Refuerzo Académico: Curso 5',
        date: '2021-08-19',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '8:00',
        endTime: '9:30',
        professor: 'ANA REYES',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 123,
        reservationCode: 1,
        name: 'Refuerzo Académico: Curso 4',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Refuerzo Académico: Curso 5',
        shortDescription: 'Refuerzo Académico: Curso 5',
        date: '2021-10-21',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '8:00',
        endTime: '10:30',
        professor: 'ANA REYES',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 124,
        reservationCode: 1,
        name: 'Refuerzo Académico: Curso 3',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'Refuerzo Académico: Curso 5',
        shortDescription: 'Refuerzo Académico: Curso 5',
        date: '2021-10-21',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '9:00',
        endTime: '10:30',
        professor: 'ANA REYES',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 125,
        reservationCode: 20211020000935,
        name: 'INTRODUCCION A LA MATEMATICA P',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'INTRODUCCION A LA MATEMATICA P',
        shortDescription: 'INTRODUCCION A LA MATEMATICA P',
        date: '2021-10-23',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '20:00',
        endTime: '21:30',
        professor: 'CALLATA CARPIO,HENRY GEORGE',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 125,
        reservationCode: 20211020000935,
        name: 'TEST REINFORCEMENT 7',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'TEST REINFORCEMENT 7',
        shortDescription: 'TEST REINFORCEMENT 7',
        date: '2021-10-28',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '12:30',
        endTime: '13:30',
        professor: 'CALLATA CARPIO,HENRY GEORGE',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 125,
        reservationCode: 20211020000935,
        name: 'TEST REINFORCEMENT 19',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'TEST REINFORCEMENT 19',
        shortDescription: 'TEST REINFORCEMENT 19',
        date: '2021-10-28',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '15:30',
        endTime: '17:30',
        professor: 'CALLATA CARPIO,HENRY GEORGE',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 125,
        reservationCode: 20211020000935,
        name: 'TEST REINFORCEMENT 22',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'TEST REINFORCEMENT 22',
        shortDescription: 'TEST REINFORCEMENT 22',
        date: '2021-10-22',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '10:30',
        endTime: '11:30',
        professor: 'CALLATA CARPIO,HENRY GEORGE',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 125,
        reservationCode: 20211020000935,
        name: 'TEST REINFORCEMENT 28',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'TEST REINFORCEMENT 28',
        shortDescription: 'TEST REINFORCEMENT 28',
        date: '2021-10-22',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '19:30',
        endTime: '20:30',
        professor: 'CALLATA CARPIO,HENRY GEORGE',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 125,
        reservationCode: 20211020000935,
        name: 'TEST REINFORCEMENT 29',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'TEST REINFORCEMENT 29',
        shortDescription: 'TEST REINFORCEMENT 29',
        date: '2021-10-22',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '19:00',
        endTime: '20:00',
        professor: 'CALLATA CARPIO,HENRY GEORGE',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 125,
        reservationCode: 20211020000935,
        name: 'TEST REINFORCEMENT 30',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'TEST REINFORCEMENT 30',
        shortDescription: 'TEST REINFORCEMENT 30',
        date: '2021-10-28',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '19:30',
        endTime: '20:30',
        professor: 'CALLATA CARPIO,HENRY GEORGE',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 125,
        reservationCode: 20211020000935,
        name: 'TEST REINFORCEMENT 30',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'TEST REINFORCEMENT 30',
        shortDescription: 'TEST REINFORCEMENT 30',
        date: '2021-10-29',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '10:30',
        endTime: '12:30',
        professor: 'CALLATA CARPIO,HENRY GEORGE',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 125,
        reservationCode: 20211020000935,
        name: 'TEST REINFORCEMENT 30',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'TEST REINFORCEMENT 30',
        shortDescription: 'TEST REINFORCEMENT 30',
        date: '2021-10-29',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '12:00',
        endTime: '13:45',
        professor: 'CALLATA CARPIO,HENRY GEORGE',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      },
      {
        id: 125,
        reservationCode: 20211020000935,
        name: 'TEST REINFORCEMENT 30',
        shortName: '',
        type: {
          idType: '',
          name: 'Some Name'
        },
        course: {
          id: ''
        },
        description: 'TEST REINFORCEMENT 30',
        shortDescription: 'TEST REINFORCEMENT 30',
        date: '2021-10-30',
        today: false,
        capacity: 10,
        address: 'Some Address',
        idZoom: 'zoom.us/',
        link: 'zoom.us/',
        startTime: '8:00',
        endTime: '10:15',
        professor: 'CALLATA CARPIO,HENRY GEORGE',
        isSubscribed: true,
        tag: {
          subscrib: 'S',
          remote: 'R',
          present: 'P',
          free: 'F'
        }
      }
    ]
  }
};

const dataDetail = {
  Reinforcement: {
    id: 125,
    name: 'Taller - Inglés II Universidad Nacional San marcos lunes',
    eventImage: 'Expresiones-otros.png',
    startDate: 1702663200000,
    endDate: 1702670400000,
    eventType: {
      id: 1,
      name: 'WORKSHOPS'
    },
    eventSubtype: {
      id: 1,
      name: 'Culturales'
    },
    modality: {
      code: 'R',
      description: 'P'
    },
    isOnly: true,
    isSubscribed: false,
    isToday: true,
    isFeatured: true,
    isVariedSchedule: true,
    isRescheduled: false,
    nameTeacher: 'PROFESOR SOVERO',
    vacancies: 100,
    date: 1702598400000,
    hourStart: '18:00',
    hourEnd: '20:00',
    code: '1515210053',
    type: {
      code: 'TUT',
      description: 'Taller'
    },
    schedule: [
      {
        idDay: 2,
        startTime: '12:45',
        endTime: '14:45'
      }
      // {
      //   idDay: 3,
      //   startTime: '14:00',
      //   endTime: '16:00'
      // },
      // {
      //   idDay: 4,
      //   startTime: '16:00',
      //   endTime: '18:00'
      // }
    ],
    scheduleDetail: [
      {
        idDay: 2,
        date: 1656979200000,
        startTime: '12:45',
        endTime: '14:45'
      },
      {
        idDay: 3,
        date: 1657065600000,
        startTime: '14:00',
        endTime: '16:00'
      },
      {
        idDay: 4,
        date: 1657152000000,
        startTime: '16:00',
        endTime: '18:00'
      }
    ],
    organizer: {
      id: 3,
      name: 'Internacional'
    },
    description:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry',
    link: 'https://www.google.com/',
    linkMeet: '',
    classroom: 'POLIDEPORTIVO 1-TORRE A',
    flat: '1',
    campus: 'Lima Sur',
    address: 'Carretera Antigua Panamericana Sur Km. 16.5 Villa el Salvador',
    isExist: true,
    isAccessible: true
  }
};

export default class ReinforcementDataStoreMock
  implements ReinforcementDataStore
{
  getDetailReinforcementById() {
    return dataDetail.Reinforcement;
  }

  subscribeReinforcements(reinforcementId: number) {
    if (reinforcementId === 2) {
      return {
        status: 'OK',
        data: {
          result: true,
          code: '20230504007590',
          date: 1683158400000,
          hourStart: '17:00',
          hourEnd: '17:45',
          description: 'OK'
        },
        message: 'OK'
      };
    }
    if (reinforcementId === 3) {
      return {
        status: 'No vacancies',
        data: {
          result: true,
          code: '20230504007590',
          date: 1683158400000,
          hourStart: '17:00',
          hourEnd: '17:45',
          description: 'OK'
        },
        message: 'No vacancies'
      };
    }

    if (reinforcementId === 4) {
      return {
        status: 'ZOOMACCOUNTNOTEXISTS',
        data: {
          result: true,
          code: '20230504007590',
          date: 1683158400000,
          hourStart: '17:00',
          hourEnd: '17:45',
          description: 'OK'
        },
        message: 'ZOOMACCOUNTNOTEXISTS'
      };
    }

    if (reinforcementId === 5) {
      return {
        status: 'ZOOMACCOUNTDISABLE',
        data: {
          result: true,
          code: '20230504007590',
          date: 1683158400000,
          hourStart: '17:00',
          hourEnd: '17:45',
          description: 'OK'
        },
        message: 'ZOOMACCOUNTDISABLE'
      };
    }
    return {
      status: 'OK',
      data: {
        result: true,
        code: '20230504007590',
        date: 1683158400000,
        hourStart: '17:00',
        hourEnd: '17:45',
        description: 'OK'
      },
      message: 'OK'
    };
  }

  getCoursesWithReinforcements() {
    return [
      {
        catalog: '100000S28T',
        hasTutorships: true,
        hasWorkshops: false,
        id: '014714',
        name: 'FORMACION PARA LA INVESTIGACION'
      },
      {
        catalog: '100000S33T',
        hasTutorships: false,
        hasWorkshops: true,
        id: '014712',
        name: 'GOBIERNO DE TIC'
      },
      {
        catalog: '100000U20E',
        hasTutorships: false,
        hasWorkshops: true,
        id: '013991',
        name: 'CALIDAD DE SERVICIO DE TI'
      }
    ];
  }

  getReinforcementsByCourse() {
    return {
      // reinforcementsByCourse: {
      reinforcements: [
        {
          id: 125,
          reservationCode: 20211020000935,
          name: 'FORMACION PARA LA INVESTIGACION',
          nameTeacher: 'Marco,G22',
          shortName: '',
          type: {
            idType: '',
            name: 'Some Name'
          },
          course: {
            id: '014714'
          },
          description: 'FORMACION PARA LA INVESTIGACION',
          shortDescription: 'FORMACION PARA LA INVESTIGACION',
          date: 1702663200000,
          today: true,
          hourStart: '18:00',
          hourEnd: '19:00',
          capacity: 10,
          address: 'Some Address',
          modality: {
            code: 'P'
          },
          idZoom: 'zoom.us/',
          link: 'zoom.us/',
          startTime: '18:00',
          endTime: '19:00',
          professor: 'CALLATA CARPIO,HENRY GEORGE',
          isSubscribed: false,
          isRescheduled: true,
          isCancel: false,

          isFeatured: true,
          tag: {
            subscrib: 'S',
            remote: 'R',
            present: 'P',
            free: 'F'
          }
        },
        {
          id: 125,
          reservationCode: 20211020000935,
          name: 'FORMACION PARA LA INVESTIGACION',
          nameTeacher: 'Marco,G22',
          shortName: '',
          type: {
            idType: '',
            name: 'Some Name'
          },
          course: {
            id: '014714'
          },
          description: 'FORMACION PARA LA INVESTIGACION',
          shortDescription: 'FORMACION PARA LA INVESTIGACION',
          date: 1702663200000,
          today: true,
          hourStart: '18:00',
          hourEnd: '19:00',
          capacity: 10,
          address: 'Some Address',
          modality: {
            code: 'P'
          },
          idZoom: 'zoom.us/',
          link: 'zoom.us/',
          startTime: '18:00',
          endTime: '19:00',
          professor: 'CALLATA CARPIO,HENRY GEORGE',
          isSubscribed: false,
          isRescheduled: true,
          isCancel: false,

          isFeatured: true,
          tag: {
            subscrib: 'S',
            remote: 'R',
            present: 'P',
            free: 'F'
          }
        },
        {
          id: 125,
          reservationCode: 20211020000935,
          name: 'REINFORCEMENT 2024',
          isFeatured: true,
          nameTeacher: 'Doctor Fernando',
          shortName: '',
          type: {
            idType: '',
            name: 'Some Name'
          },
          course: {
            id: ''
          },
          description: 'REINFORCEMENT 2024',
          shortDescription: 'REINFORCEMENT 2024',
          date: new Date().getTime(),
          today: true,
          hourStart: '10:02',
          hourEnd: '23:15',
          capacity: 10,
          address: 'Some Address',
          modality: {
            code: 'P'
          },
          idZoom: 'zoom.us/',
          link: 'zoom.us/',
          startTime: '20:00',
          endTime: '23:00',
          professor: 'CALLATA CARPIO,HENRY GEORGE',
          isSubscribed: true,
          isRescheduled: true,
          isCancel: true,
          tag: {
            subscrib: 'S',
            remote: 'R',
            present: 'P',
            free: 'F'
          }
        }
      ],
      featureds: [
        {
          id: 125,
          reservationCode: 20211020000935,
          hourStart: '20:25',
          hourEnd: '23:25',
          name: 'TEST REINFORCEMENT 30',
          nameTeacher: 'Luis fernando',
          shortName: '',
          type: {
            idType: '',
            name: 'Some Name'
          },
          course: {
            id: ''
          },
          modality: {
            code: 'P'
          },
          description: 'TEST REINFORCEMENT 30',
          shortDescription: 'TEST REINFORCEMENT 30',
          date: '2022-09-08',
          today: false,
          capacity: 10,
          address: 'Some Address',
          idZoom: 'zoom.us/',
          link: 'zoom.us/',
          startTime: '12:00',
          endTime: '13:45',
          professor: 'CALLATA CARPIO,HENRY GEORGE',
          isSubscribed: true,
          isFeatured: true,
          tag: {
            subscrib: 'S',
            remote: 'R',
            present: 'P',
            free: 'F'
          }
        }
      ]
      // }
    };
  }

  unsubscribeReinforcements() {
    return {
      result: true,
      description: 'ok'
    };
  }

  subscribeToWaitingList(parameters: any) {
    return {
      status: 'OK',
      data: {},
      message: parameters ?? 'OK'
    };
  }

  unsubscribeToWaitingList(parameters: any) {
    return {
      status: 'OK',
      data: {},
      message: parameters ?? 'OK'
    };
  }

  async getReinforcements() {
    return data.challengeCourses;
  }
}
